<template>
    <v-container fluid>
        <v-data-iterator
            :items="displayedHeaders"
            :items-per-page.sync="blocks"
            hide-default-footer
        >
            <template v-slot:default="props">
                <v-row>
                    <v-card>
                        <v-col
                            class="column-divider"
                            v-for="(columns, index) in props.items"
                            :key="index"
                            cols="12"
                            sm="12"
                            md="6"
                            lg="6"
                        >
                            <v-list dense>
                                <data-record-list-item-value
                                    v-for="column in columns"
                                    :key="column.id"
                                    :column="column"
                                    :item="item"
                                />
                            </v-list>
                        </v-col>
                    </v-card>
                </v-row>
            </template>
        </v-data-iterator>
    </v-container>
</template>

<script>
import _ from "lodash";
import DynamicInput from "@/Shared/DathaGatherings/Common/DynamicInput";
import DataRecordListItemValue from "@/Shared/DathaGatherings/Common/Records/DataRecordListItemValue";

export default {
    name: "DataRecordsExtendedRow",
    components: {DataRecordListItemValue, DynamicInput},
    props: {
        blocks: {
            type: Number,
            default: 2,
        },

        item: {
            type: Object,
            require: true,
        },

        headers: {
            type: Array,
            require: true,
        },

        showHidden: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {

        }
    },

    computed: {
        displayedHeaders() {
            const headers = this.showHidden? this.headers : this.headers.filter(header => !header.show);

            return _.chunk(headers, Math.ceil(headers.length / this.blocks));
        },
    },
}
</script>

<style scoped>
    .v-list-item{
        padding: 0 16px;
    }

    .row {
        justify-content: center !important;
        align-content: center !important;
    }

    .column-divider:first-child {
        border-top-right-radius: 0px !important;
        border-right: 1px solid hsla(0, 0%, 86%, 1) !important;
    }

    .v-card {
        margin-top: 20px;
        display: flex !important;
        box-shadow: none !important;
        width: 100%;
    }
</style>
